import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_149: DocMigration = {
  maxSchemaVersion: "0.0.149",
  description: "Door props fix height swapped doors",
  apply(json: any) {
    for (const id in json.settings) {
      const setting = json.settings[id];

      if (setting.type !== "EXTERIOR_PROP_SETTINGS") {
        continue;
      }

      for (const key in setting.propTypes) {
        const prop = setting.propTypes[key];
        const result = propNameSwaps[prop.name];
        if (result) {
          prop.name = result;
          setting.propTypes[key] = prop;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_149;

type PropIdSwapTable = { [oldId: string]: string };

const propNameSwaps: PropIdSwapTable = {
  // door heights were swapped between tall and short
  ["DoorExt_Single36_Panel3_01"]: "DoorExt_Single36_Panel3_02",
  // door heights were swapped between tall and short
  ["DoorExt_Single36_Panel3_02"]: "DoorExt_Single36_Panel3_01",
};
